export default "__VITE_ASSET__D2DsCD18__"